import { render, staticRenderFns } from "./ComparisonOfClassHistory.vue?vue&type=template&id=14b2f5d2&scoped=true&"
import script from "./ComparisonOfClassHistory.vue?vue&type=script&lang=js&"
export * from "./ComparisonOfClassHistory.vue?vue&type=script&lang=js&"
import style0 from "./ComparisonOfClassHistory.vue?vue&type=style&index=0&id=14b2f5d2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b2f5d2",
  null
  
)

export default component.exports